<template>
  <div class="modal-overlay" @click="$emit('close')">
    <div class="modal" @click.stop>
      <h2>Login to Your Account</h2>
      
      <div v-if="alert.message" :class="['alert', alert.type === 'success' ? 'alert-success' : 'alert-error']">
        {{ alert.message }}
      </div>
      
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="login-email">Email</label>
          <input 
            type="email" 
            id="login-email" 
            v-model="form.email" 
            placeholder="Enter your email" 
            required>
        </div>
        
        <div class="form-group">
          <label for="login-password">Password</label>
          <input 
            type="password" 
            id="login-password" 
            v-model="form.password" 
            placeholder="Enter your password" 
            required>
        </div>
        
        <div class="form-buttons">
          <button type="submit" class="btn-primary" :disabled="loading">
            <span v-if="loading" class="spinner"></span>
            <span v-else>Login</span>
          </button>
          <button type="button" class="btn-secondary" @click="$emit('close')">Cancel</button>
        </div>
        
        <p style="text-align: center; margin-top: 15px;">
          Don't have an account? 
          <a href="#" style="color: #4dabf7;" @click.prevent="$emit('switch-to-register')">
            Register here
          </a>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
// Mock API (实际项目中应该调用真实的API)
const mockApi = {
  login: function(email, password) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (email === 'demo@roadlink.com' && password === 'password') {
          resolve({
            success: true,
            user: {
              id: 1,
              username: 'demo_user',
              email: email
            },
            token: 'mock_jwt_token_12345'
          });
        } else {
          reject({
            success: false,
            message: 'Invalid email or password'
          });
        }
      }, 1500);
    });
  }
};

export default {
  name: 'LoginModal',
  data() {
    return {
      loading: false,
      form: {
        email: 'demo@roadlink.com',
        password: 'password'
      },
      alert: {
        message: '',
        type: ''
      }
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true;
      this.alert.message = '';
      
      try {
        const response = await mockApi.login(this.form.email, this.form.password);
        
        if (response.success) {
          // 存储用户信息
          localStorage.setItem('user', JSON.stringify(response.user));
          localStorage.setItem('token', response.token);
          
          // 通知父组件登录成功
          this.$emit('success', response.user);
          
          this.alert.message = 'Login successful!';
          this.alert.type = 'success';
        }
      } catch (error) {
        this.alert.message = error.message;
        this.alert.type = 'error';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  padding: 30px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
}

.modal h2 {
  color: #1a3a5f;
  margin-bottom: 20px;
  text-align: center;
}

.form-buttons {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.alert {
  padding: 12px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.alert-error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255,255,255,.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>